import type { MachineState } from '../api/types'

const timezone = 'Asia/Bangkok'
export function formatDateTime(value: string | Date | null | undefined): string {
  if (!value) return '—'
  return new Intl.DateTimeFormat('en-GB', {
    dateStyle: 'medium',
    timeStyle: 'short',
    timeZone: timezone,
  }).format(new Date(value))
}
export function formatDate(value: string | Date | null | undefined): string {
  if (!value) return '—'
  return new Intl.DateTimeFormat('en-GB', { dateStyle: 'medium', timeZone: timezone }).format(
    new Date(value),
  )
}
export function formatNumber(value: number | null | undefined, digits = 0): string {
  if (value == null || Number.isNaN(value)) return '—'
  return new Intl.NumberFormat('en-US', {
    maximumFractionDigits: digits,
    minimumFractionDigits: digits,
  }).format(value)
}
export function formatPercent(value: number | null | undefined, digits = 0): string {
  return value == null ? '—' : `${formatNumber(value, digits)}%`
}
export function formatMemory(value: number | null | undefined): string {
  if (value == null) return '—'
  return value >= 1024 ? `${formatNumber(value / 1024, 1)} GiB` : `${formatNumber(value)} MiB`
}
export function formatHours(value: number | null | undefined): string {
  if (value == null) return '—'
  return value < 1 ? `${formatNumber(value * 60)} min` : `${formatNumber(value, value < 10 ? 1 : 0)} h`
}
export const stateLabel: Record<MachineState, string> = {
  computing: 'Computing',
  serving: 'Serving models',
  reserved: 'Reserved',
  maintenance: 'Maintenance',
  ready: 'Ready for research',
  incident: 'Incident',
  offline: 'Offline',
  unknown: 'Awaiting telemetry',
}
